/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import React, { memo, useState } from "react";
import { Responsive, WidthProvider } from "react-grid-layout/legacy";
import { BiCopy } from "react-icons/bi";
import { FiEdit } from "react-icons/fi";
import { MdDeleteForever } from "react-icons/md";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { v4 as uuid } from "uuid";

import DialGuegeLayout from "@/components/LayoutCharts/DialGuegeLayout";
import Layout3DTank from "@/components/LayoutCharts/Layout3DTank";
import LayoutCounter from "@/components/LayoutCharts/LayoutCounter";
import LayoutDynamicBox from "@/components/LayoutCharts/LayoutDynamicBox";
import LayoutSplitCounter from "@/components/LayoutCharts/LayoutSplitCounter";
import LayoutTextBox from "@/components/LayoutCharts/LayoutTextBox";
import TableChart from "@/components/LayoutCharts/TableChart";
import LayoutAlarmNotification from "@/components/LayoutCharts/LayoutAlarmNotification";
import ReportChartFetch from "./ReportChartFetch";
import { userRole } from "@/constant";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const ReportLayout = memo(({ gridData, setGridData, setLayouts, layouts, mode, setEditItem = () => {}, setComponentModal = () => {} }) => {
  const { userDetails } = useSelector((state) => state.user);
  const [editId, setEditId] = useState("");
  const [dialChangeKey, setDialChangeKey] = useState(new Date());
  const [show, setShow] = useState(false);

  const onLayoutChange = (layout, data) => {
    setLayouts(data);
    setDialChangeKey(new Date());
  };

  const handlerRemove = (id) => {
    const newData = gridData.filter((data) => data._id !== id);
    setGridData(newData);
  };

  const handlerUpdate = (item) => {
    setEditItem(item);
    setComponentModal(true);
  };

  const defaultLayout = {
    w: 3, // default width
    h: 3, // default height
    x: 0, // default x position
    y: 0, // default y position
    moved: false,
    static: false,
  };

  const handleCopy = (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to copy this tile?.",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        setGridData([
          ...gridData,
          {
            ...item,
            _id: uuid(),
            chartTitle: item.chartTitle + " (copy)",
          },
        ]);
      }
    });
  };

  const handleRemove = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to remove this tile?.",
      //icon: "warning",
      dangerMode: true,
      showCancelButton: true,
      confirmButtonText: "Confirm",
    }).then((result) => {
      if (result.isConfirmed) {
        handlerRemove(id);
      }
    });
  };

  return (
    <div>
      <ResponsiveReactGridLayout
        className={`layout ${mode === "view" ? "bg-layout client_view" : ""}`}
        id="layout1"
        rowHeight={80}
        layouts={layouts}
        onLayoutChange={onLayoutChange}
        // onResize={() => setDialChangeKey(new Date())}
        draggableCancel=".clickBtn"
        isDraggable={mode === "view" ? false : true}
        isResizable={mode === "view" ? false : true}
        verticalCompact={false}
        breakpoints={{ lg: 900, md: 700, sm: 500, xs: 400, xxs: 300 }}
        cols={{ lg: 16, md: 12, sm: 8, xs: 4, xxs: 2 }}
      >
        {gridData?.map((item, idx) => (
          <div
            className="dashboardTiles"
            key={item._id}
            // data-grid={{ w: 3, h: 3, x: 0, y: 0 }}
            data-grid={layouts?.lg?.[idx] || defaultLayout}
          >
            <div className="position-relative h-100 d-flex align-items-center">
              {[userRole.superAdmin, userRole.businessAdmin, userRole.admin, userRole.installer].includes(userDetails.role) && mode !== "view" ? (
                <div className="d-flex justify-content-end align-items-center position-absolute layout-controls" style={{ top: 0, right: 5, zIndex: 10 }}>
                  <div className="clickBtn" onClick={() => handleCopy(item)}>
                    <BiCopy className="text-secondary me-2" />
                  </div>
                  <div className="clickBtn" onClick={() => handlerUpdate(item)}>
                    <FiEdit className="text-secondary me-1" />
                  </div>
                  <div className="clickBtn" onClick={() => handleRemove(item._id)}>
                    <MdDeleteForever className="fs-5 text-secondary" />
                  </div>
                </div>
              ) : (
                ""
              )}
              {["bar", "line", "pie", "comboBar"].includes(item.component) ? (
                <div className="p-2 h-100 w-100">
                  <ReportChartFetch data={item} type={item.component} />
                </div>
              ) : item.component === "dial" ? (
                <DialGuegeLayout data={item} dialChangeKey={dialChangeKey} />
              ) : // <RedialChartLayout data={item}/>
              item.component === "splitCounter" ? (
                <LayoutSplitCounter data={item} />
              ) : item.component === "textBox" ? (
                <LayoutTextBox data={item} />
              ) : item.component === "tank" ? (
                <Layout3DTank data={item} />
              ) : item.component === "dynamicBox" ? (
                <LayoutDynamicBox data={item} />
              ) : item.component === "table" ? (
                <TableChart {...item} />
              ) : item.component === "alarmNotification" ? (
                <LayoutAlarmNotification data={item} />
              ) : (
                item.component === "counter" && <LayoutCounter data={item} />
              )}
            </div>
          </div>
        ))}
      </ResponsiveReactGridLayout>
    </div>
  );
});

export default ReportLayout;

ReportLayout.displayName = "ReportLayout";
ReportLayout.propTypes = {
  gridData: PropTypes.array,
  setGridData: PropTypes.func,
  setLayouts: PropTypes.func,
  layouts: PropTypes.object,
  mode: PropTypes.string,
  setEditItem: PropTypes.func,
  setComponentModal: PropTypes.func,
};
